module.exports = __webpack_public_path__ + "img/vertical_7_4_7016.de37d80e.png";